export default __webpack_public_path__ + "static/media/course.71d73534.svg";